export default __webpack_public_path__ + "static/media/onboardingAside.13a10308.jpg";